import { ProjectTerminologyType } from 'src/models/Campaigns/misc';

export type PlusSubscriptionEventType = {
  EventName: string | null;
  CustomerType: string | null;
  Billing: string | null;
  Plan: string | null;
  Total: string | null;
  Email: string | null;
  Country: string | null;
  Group: string | null;
  Reason: string | null;
};

export type PlusSubscriptionContinueWithPlusSubscriptionPlanRequestType = {
  PlanID: string;
  HostedPageID: string;
};

export type PlusSubscriptionContinueWithPlusSubscriptionPlanResponseType =
  PlusSubscriptionContinueWithPlusSubscriptionPlanRequestType & {
    PlusSubscriptionEventModel: PlusSubscriptionEventType | null;
  };

export type PlusSubscriptionContinueWithTrialPlanResponseType = {
  PlusSubscriptionEventModel: PlusSubscriptionEventType | null;
};

export enum PlusSubscriptionModalTypeEnum {
  PlanSelection = 1,
  PaymentFailed = 2,
  PlanPreselected = 3,
}

export type PlusSubscriptionModalInfoResponseType = {
  PlusSubscriptionModalType: PlusSubscriptionModalTypeEnum | null;
  IsPlusSubscriptionAvailable: boolean;
  IsFreeTrialAvailable: boolean;
  IsRallyUpPlusFeatureFlagEnabled: boolean;
  PlanSelectionModalInfo: {
    IsFreeTrialExpired: boolean;
    Plans: {
      OrganizationSubscriptionPlanCode: number;
      SubscriptionPeriodFee: number;
      PerTransactionFee: number;
    }[];
    PlusSubscriptionCustomerInfo: {
      FirstName: string;
      LastName: string;
      Email: string;
      CompanyName: string;
    };
    ComparePricingLink: string;
  };
  FailedPaymentModalInfo: {
    IsGracePeriodExpired: boolean;
    ChargebeeSelfServePortalUrl: string;
    FailedPaymentReason: string;
    GracePeriodExpirationDate: string | null;
  };
  PlanPreselectedModalInfo: {
    OrganizationSubscriptionPlanCode: number;
    SubscriptionPeriodFee: number;
    PerTransactionFee: number;
    SubscriptionPeriodMonthsCount: number;
    PlusSubscriptionCustomerInfo: {
      FirstName: string;
      LastName: string;
      Email: string;
      CompanyName: string;
    };
  } | null;
  IsSubscriptionDialogHeaderVisible: boolean;
};

export type UpsellLoadUpdatePricingDialogResponseType = {
  PercentagePartLabel: string;
  ProjectTerminology: ProjectTerminologyType;
  SupporterTerminology: ProjectTerminologyType;
  IsHeaderVisible: boolean;
  IsSwitchBackStringVisible: boolean;
};
